import { css, cx } from '@emotion/css';
import { Color } from 'css/theme';
import * as React from 'react';
const overlay = css({
  position: 'fixed',
  left: '0px',
  right: '0px',
  top: '0px',
  bottom: '0px',
  zIndex: 1000,
  background: 'rgba(49, 62, 73, 0.9)',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
});

const wrapper = css({
  width: '100%',
  padding: '2rem',
});

const container = css({
  borderRadius: '10px',
  backgroundColor: Color.White,
  marginLeft: 'auto',
  marginRight: 'auto',
  width: '100%',
  maxWidth: '500px',
  paddingLeft: '2rem',
  paddingRight: '2rem',
  paddingTop: '1.75rem',
  paddingBottom: '1.75rem',
});

interface Props {
  children: React.ReactNode;
  className?: string;
  onClose: () => void;
}

const Modal = ({ children, className, onClose }: Props) => {
  return (
    <div
      aria-hidden={true}
      className={overlay}
      onClick={e => {
        e.preventDefault();
        onClose();
      }}
    >
      <div className={wrapper}>
        <div role="presentation" onClick={e => e.stopPropagation()} className={cx([container, className])}>
          {children}
        </div>
      </div>
    </div>
  );
};

export default Modal;
